import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetCheckoutContentApplicationErrors,
  GetCheckoutContentIdentifiers,
  GetCheckoutContentOptions,
  GetCheckoutContentResponse,
  getCheckoutContent as universalGetCheckoutContent,
} from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getCheckoutContent(
  httpClient: HttpClient
): GetCheckoutContentSignature {
  return (
    identifiers: NonNullablePaths<
      GetCheckoutContentIdentifiers,
      `appId` | `componentId`,
      2
    >,
    options?: GetCheckoutContentOptions
  ) =>
    universalGetCheckoutContent(
      identifiers,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetCheckoutContentSignature {
  /**
   * Retrieves a CheckoutContent.
   */
  (
    identifiers: NonNullablePaths<
      GetCheckoutContentIdentifiers,
      `appId` | `componentId`,
      2
    >,
    options?: GetCheckoutContentOptions
  ): Promise<
    GetCheckoutContentResponse & {
      __applicationErrorsType?: GetCheckoutContentApplicationErrors;
    }
  >;
}

export {
  CheckoutContent,
  CheckoutContentProvider,
  GetCheckoutContentIdentifiers,
  GetCheckoutContentOptions,
  GetCheckoutContentRequest,
  GetCheckoutContentResponse,
} from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';
